module.exports = __webpack_public_path__ + "static/media/03.1f1c6d32.jpg";